import { render, staticRenderFns } from "./AriticleCard.vue?vue&type=template&id=5a245b73&scoped=true&"
import script from "./AriticleCard.vue?vue&type=script&lang=js&"
export * from "./AriticleCard.vue?vue&type=script&lang=js&"
import style0 from "./AriticleCard.vue?vue&type=style&index=0&id=5a245b73&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a245b73",
  null
  
)

export default component.exports